























































import { namespace } from 'vuex-class';
import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import { CART } from '@/store/types';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';
import {
  EssenceItemDto,
  EssencesApi,
  LabelSelectionApi,
  ProductDto
} from '@eurogast/hub-client-typescript';
import { NumberFormatter } from '@/services/NumberFormatter';
import { Big } from 'big.js';
import ConfirmationActionButton from '@/common/ConfirmationActionButton.vue';
import {
  Cart,
  CartItem
} from '@/services/cart/model/cart';
import { CartEvents } from '@/services/cart/model/cart-events';
import { DependencyService } from '@/services/DependencyService';
import PageCartItem from '@/cart-page/cart/section/PageCartItem.vue';
import CartItemGroup from '@/domain/cart/CartItemGroup';
import MatomoEvents from '@/matomo/events/MatomoEvents';
import UnavailableProductSection from '@/cart-page/cart/section/unavailable/UnavailableProductSection.vue';

const cart = namespace(CART);

@Component({
  components: {
    UnavailableProductSection,
    PageCartItem,
    ConfirmationActionButton
  }
})
export default class ProductSection extends Vue {

  get allAvailableCartItems(): CartItem[] {
    return this.cart.items
        .filter((item) => !this.removedItems.find((e) => e.sku === item.sku))
        .filter((item) => item.product.availability === ProductDto.AvailabilityEnum.ACTIVE)
        .concat(this.removedItems)
        .sort((a, b) => a.sku.localeCompare(b.sku));
  }

  get unavailableCartItems(): CartItem[] {
    return this.cart.items
        .filter((it) => it.product.availability !== ProductDto.AvailabilityEnum.ACTIVE)
        .sort((a, b) => a.sku.localeCompare(b.sku));
  }

  get cartItemsGroupedByCategory(): CartItemGroup[] {
    const itemsByCategory = new Map<string, CartItem[]>();

    this.allAvailableCartItems.forEach((item) => {
      const categoryId = item.product.resolvedCategory.id;
      if (!itemsByCategory.has(categoryId)) {
        itemsByCategory.set(categoryId, []);
      }
      itemsByCategory.get(categoryId).push(item);
    });

    return Array.from(
        itemsByCategory,
        ([groupId, cartItems]) => new CartItemGroup(groupId, cartItems)
    );
  }

  get totalPrice() {
    return NumberFormatter.formatPrice(this.cartService.totalPrice);
  }

  get showPrice() {
    return !this.cartService.totalPrice.eq(new Big('0.0'));
  }

  @cart.State('cart')
  public cart: Cart;
  @Prop({required: false, default: null})
  public localOrderTemplateList: string;
  @Prop({required: false, default: true})
  public showLabelPrintIcon: boolean;
  @Prop({required: false, default: true})
  public showOrderTemplateIcon: boolean;


  public essenceList: EssenceItemDto[] = [];
  public labelSelection: string[] = [];
  public removedItems: CartItem[] = [];


  private cartService = DependencyService.getCartService();
  private essencesApi = ApiService.wrap(EssencesApi);
  private labelSelectionApi = ApiService.wrap(LabelSelectionApi);


  public inLabelSelection(sku: string): boolean {
    return this.labelSelection.indexOf(sku) !== -1;
  }

  public clearCart() {
    MatomoEvents.forCartPage.removeAllProducts.publish();
    this.cartService.clearItems();
    (this.$refs.confirmationActionButton as ConfirmationActionButton).hideDialog();
  }

  public getProductIndexConsiderAllGroups(
      indexInGroup: number,
      currentGroupIndex: number
  ) {
    const numberOfItemsBefore = this.cartItemsGroupedByCategory
        .slice(0, currentGroupIndex)
        .map((e) => e.items)
        .reduce((acc: number, el) => acc + el.length, 0);
    return indexInGroup + numberOfItemsBefore;
  }

  public mounted() {
    const skus = this.cart.items.map((item) => item.sku);
    if (skus.length > 0) {
      this.queryEssenceApi(skus);
      this.queryLabelSelection();
    }

    Vue.prototype.$events.$on(CartEvents.ITEM_SAVED, (item: CartItem) => {
      this.removedItems = this.removedItems.filter((e) => e.sku !== item.sku);
    });
    Vue.prototype.$events.$on(CartEvents.ITEM_REMOVED, (e: CartItem) => {
      e.removed = true;
      this.removedItems.push(e);
    });
  }

  private async queryEssenceApi(skus: string[]) {
    try {
      this.essenceList = await this.essencesApi.getLastThreeEssenceItemsFromList(
          ConfigService.getTenant(),
          ConfigService.currentCustomerId,
          skus
      );
    } catch (e) {
      await ApiService.defaultErrorHandler(e);
    }
  }

  private async queryLabelSelection() {
    try {
      this.labelSelection = await this.labelSelectionApi.getOwnLabelSkus(
          ConfigService.getTenant(),
          ConfigService.currentCustomerId
      );
    } catch (e) {
      await ApiService.defaultErrorHandler(e);
    }
  }


  public getEssenceList(sku: string): EssenceItemDto[] {
    return this.essenceList
        .filter((x) => x.sku === sku)
        .sort((a, b) => b.date.localeCompare(a.date));
  }

}
